<template>
    <experiment-relationship-config-types-list
        :experiment-relationship-configs="experimentRelationshipConfigs"
        :show-inheritance-from-schema-config="true"
        @save-experiment-relationship-config="handleSaveExperimentRelationshipConfig"
        @deleted-experiment-relationship-config="fetchRelationshipConfigsForSelectedExperimentGroup"
    />
</template>
<script setup lang="ts">

import { ref } from "vue";
import {
    SavedExperimentGroup,
} from "@/services/experimentGroups/experimentGroupsAPI";
import { withLoadingScreen } from "@/lib/loading";
import {
    ExperimentSetupRelationshipConfig,
    ManageExperimentSetupRelationshipConfigDTO,
    RelationshipConfigsForType,
    SavedExperimentSetupRelationshipConfig,
} from "@/services/experimentRelationships/models";
import { buildExperimentConfigRelationshipAPIForExperimentGroup } from "@/services/experimentRelationships/experimentRelationshipConfigsAPI";
import ExperimentRelationshipConfigTypesList
    from "@/components/ExperimentRelationshipConfigs/ExperimentRelationshipConfigTypesList.vue";

const { experimentGroup } = defineProps<{
    experimentGroup: SavedExperimentGroup;
}>();

const experimentGroupRelationshipConfigAPI = buildExperimentConfigRelationshipAPIForExperimentGroup(experimentGroup.id);
const experimentRelationshipConfigs = ref<RelationshipConfigsForType<ManageExperimentSetupRelationshipConfigDTO>[]>([]);

async function handleSaveExperimentRelationshipConfig(targetConfig: ExperimentSetupRelationshipConfig | SavedExperimentSetupRelationshipConfig) {
    await withLoadingScreen(async () => {
        await experimentGroupRelationshipConfigAPI.save({
            ...targetConfig,
            experimentGroupId: experimentGroup.id
        });

        await fetchRelationshipConfigsForSelectedExperimentGroup();
    });
}

async function fetchRelationshipConfigsForSelectedExperimentGroup() {
    await withLoadingScreen(async () => {
        experimentRelationshipConfigs.value = await experimentGroupRelationshipConfigAPI.fetchAllDTOs();
    })
}

fetchRelationshipConfigsForSelectedExperimentGroup();

</script>
